var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1098,
    height: 1098,
    viewBox: "0 0 1098 1098",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6555_439)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 1072,
    height: 1072,
    rx: 536,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.169 568.527V89.0137L580.049 103.333V570.246L508.169 568.527Z",
    fill: "#86C131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 246.175H525.225V233.992H538.627V246.175Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 246.175H549.592V233.992H561.775V246.175Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 272.979H525.225V259.577H538.627V272.979Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 272.979H549.592V259.577H561.775V272.979Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 297.344H525.225V285.161H538.627V297.344Z",
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 297.344H549.592V285.161H561.775V297.344Z",
    fill: "#F1F1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 324.148H525.225V310.746H538.627V324.148Z",
    fill: "#F1F1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 324.148H549.592V310.746H561.775V324.148Z",
    fill: "#F1F1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 349.732H525.225V337.549H538.627V349.732Z",
    fill: "#F1F1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 349.732H549.592V337.549H561.775V349.732Z",
    fill: "#F1F1F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 375.316H525.225V361.915H538.627V375.316Z",
    fill: "#F1F1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 375.316H549.592V361.915H561.775V375.316Z",
    fill: "#F1F1F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 142.62H525.225V130.437H538.627V142.62Z",
    fill: "#F1F1F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 142.62H549.592V130.437H561.775V142.62Z",
    fill: "#F1F1F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 169.422H525.225V156.021H538.627V169.422Z",
    fill: "#F1F1F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 169.422H549.592V156.021H561.775V169.422Z",
    fill: "#F1F1F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 195.006H525.225V182.823H538.627V195.006Z",
    fill: "#F1F1F1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 195.006H549.592V182.823H561.775V195.006Z",
    fill: "#F1F1F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 220.591H525.225V207.189H538.627V220.591Z",
    fill: "#F1F1F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 220.591H549.592V207.189H561.775V220.591Z",
    fill: "#F1F1F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 246.175H525.225V233.992H538.627V246.175Z",
    fill: "#F1F1F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 246.175H549.592V233.992H561.775V246.175Z",
    fill: "#F1F1F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 272.979H525.225V259.577H538.627V272.979Z",
    fill: "#F1F1F1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 272.979H549.592V259.577H561.775V272.979Z",
    fill: "#F1F1F1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 324.148H525.225V310.746H538.627V324.148Z",
    fill: "#F1F1F1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 324.148H549.592V310.746H561.775V324.148Z",
    fill: "#F1F1F1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 348.513H525.225V336.33H538.627V348.513Z",
    fill: "#F1F1F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 348.513H549.592V336.33H561.775V348.513Z",
    fill: "#F1F1F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 375.316H525.225V361.915H538.627V375.316Z",
    fill: "#F1F1F1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 375.316H549.592V361.915H561.775V375.316Z",
    fill: "#F1F1F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 400.901H525.225V388.718H538.627V400.901Z",
    fill: "#F1F1F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 400.901H549.592V388.718H561.775V400.901Z",
    fill: "#F1F1F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 426.485H525.225V413.084H538.627V426.485Z",
    fill: "#F1F1F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 426.485H549.592V413.084H561.775V426.485Z",
    fill: "#F1F1F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.627 452.07H525.225V439.887H538.627V452.07Z",
    fill: "#F1F1F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.775 452.07H549.592V439.887H561.775V452.07Z",
    fill: "#F1F1F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457 534.915V202.777L508.169 182.823V534.915H457Z",
    fill: "#92AD31"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 339.986H464.31V327.803H476.493V339.986Z",
    fill: "#F1F1F1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 339.986H488.676V327.803H502.077V339.986Z",
    fill: "#F1F1F1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 366.789H464.31V354.605H476.493V366.789Z",
    fill: "#F1F1F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 366.789H488.676V354.605H502.077V366.789Z",
    fill: "#F1F1F1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 393.591H464.31V380.189H476.493V393.591Z",
    fill: "#F1F1F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 393.591H488.676V380.189H502.077V393.591Z",
    fill: "#F1F1F1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 420.394H464.31V406.992H476.493V420.394Z",
    fill: "#F1F1F1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 420.394H488.676V406.992H502.077V420.394Z",
    fill: "#F1F1F1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 447.196H464.31V433.795H476.493V447.196Z",
    fill: "#F1F1F1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 447.196H488.676V433.795H502.077V447.196Z",
    fill: "#F1F1F1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 474H464.31V460.599H476.493V474Z",
    fill: "#F1F1F1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 474H488.676V460.599H502.077V474Z",
    fill: "#F1F1F1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 259.577H464.31V247.394H476.493V259.577Z",
    fill: "#F1F1F1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 259.577H488.676V247.394H502.077V259.577Z",
    fill: "#F1F1F1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 286.38H464.31V274.197H476.493V286.38Z",
    fill: "#F1F1F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 286.38H488.676V274.197H502.077V286.38Z",
    fill: "#F1F1F1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 314.401H464.31V301H476.493V314.401Z",
    fill: "#F1F1F1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 314.401H488.676V301H502.077V314.401Z",
    fill: "#F1F1F1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 339.986H464.31V327.803H476.493V339.986Z",
    fill: "#F1F1F1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 339.986H488.676V327.803H502.077V339.986Z",
    fill: "#F1F1F1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 366.789H464.31V354.605H476.493V366.789Z",
    fill: "#F1F1F1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 366.789H488.676V354.605H502.077V366.789Z",
    fill: "#F1F1F1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.493 393.591H464.31V380.189H476.493V393.591Z",
    fill: "#F1F1F1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.077 393.591H488.676V380.189H502.077V393.591Z",
    fill: "#F1F1F1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.049 534.915V235.211L630 236.929V534.915H580.049Z",
    fill: "#C8D912"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 370.443H591.014V360.696H599.542V370.443Z",
    fill: "#F1F1F1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 370.443H609.289V360.696H617.817V370.443Z",
    fill: "#F1F1F1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 389.936H591.014V381.408H599.542V389.936Z",
    fill: "#F1F1F1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 389.936H609.289V381.408H617.817V389.936Z",
    fill: "#F1F1F1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 410.648H591.014V400.901H599.542V410.648Z",
    fill: "#F1F1F1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 410.648H609.289V400.901H617.817V410.648Z",
    fill: "#F1F1F1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 430.14H591.014V420.394H599.542V430.14Z",
    fill: "#F1F1F1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 430.14H609.289V420.394H617.817V430.14Z",
    fill: "#F1F1F1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 449.633H591.014V439.887H599.542V449.633Z",
    fill: "#F1F1F1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 449.633H609.289V439.887H617.817V449.633Z",
    fill: "#F1F1F1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 467.908H591.014V458.161H599.542V467.908Z",
    fill: "#F1F1F1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 467.908H609.289V458.161H617.817V467.908Z",
    fill: "#F1F1F1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 292.471H591.014V282.725H599.542V292.471Z",
    fill: "#F1F1F1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 292.471H609.289V282.725H617.817V292.471Z",
    fill: "#F1F1F1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 313.183H591.014V303.437H599.542V313.183Z",
    fill: "#F1F1F1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 313.183H609.289V303.437H617.817V313.183Z",
    fill: "#F1F1F1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 332.675H591.014V322.929H599.542V332.675Z",
    fill: "#F1F1F1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 332.675H609.289V322.929H617.817V332.675Z",
    fill: "#F1F1F1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 352.168H591.014V342.422H599.542V352.168Z",
    fill: "#F1F1F1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 352.168H609.289V342.422H617.817V352.168Z",
    fill: "#F1F1F1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 370.443H591.014V360.696H599.542V370.443Z",
    fill: "#F1F1F1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 370.443H609.289V360.696H617.817V370.443Z",
    fill: "#F1F1F1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.542 389.936H591.014V381.408H599.542V389.936Z",
    fill: "#F1F1F1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.817 389.936H609.289V381.408H617.817V389.936Z",
    fill: "#F1F1F1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.287 647C547.347 616.638 565.244 563.473 627.563 534.917L457 534.915C519.298 563.473 537.201 616.638 542.287 647Z",
    fill: "#69A439"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.224 645.781C545.074 615.013 551.404 563.867 580.049 534.915H508.169C536.82 563.867 541.34 615.013 543.224 645.781Z",
    fill: "#86C131"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.202 761.577L304.912 680H319L303.935 780H281.063L266 680H281.487L293.202 761.577Z",
    fill: "#69A439"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354 680H369V780H354V680Z",
    fill: "#69A439"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.166 679C443.187 679 450.946 688.214 450.946 704.335V708.203H436.298V703.301C436.298 696.132 433.53 693.383 428.594 693.383C423.714 693.383 420.891 696.132 420.891 703.303C420.891 724.013 451 727.916 451 756.682C451 772.786 443.187 782 428.001 782C412.868 782 405 772.786 405 756.682L405.002 749.758H419.587V757.684C419.587 764.876 422.682 767.464 427.615 767.464C432.556 767.464 435.593 764.876 435.593 757.684C435.593 736.99 405.491 733.104 405.491 704.335C405.491 688.214 413.19 679 428.166 679Z",
    fill: "#69A439"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.188 780H487V680H502.188V722.865H519.53V680H535V780H519.53V737.139H502.188V780Z",
    fill: "#69A439"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.373 726.726L602.849 780H581.852L571 680H585.869L594.09 758.884L601.401 680H616.165L623.785 759.421L631.684 680H645L634.208 780H613.911L608.373 726.726Z",
    fill: "#69A439"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.425 748.267H707.021L699.727 697.728L692.425 748.267ZM727 780H711.713L709.105 761.859H690.516L687.899 780H674L689.402 680H711.612L727 780Z",
    fill: "#69A439"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.813 740.148L777.089 749.288V780H762V680H777.089V723.564L797.167 680H812L791.001 724.573L812 780H796.476L781.813 740.148Z",
    fill: "#69A439"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.131 811.438V836.151H287.364C290.933 836.151 292.877 834.5 292.877 829.254V818.31C292.877 813.106 290.933 811.438 287.363 811.438H282.131ZM304 819.041V828.53C304 840.232 298.495 846.605 287.363 846.605H282.131V874H271V801H287.364C298.495 801 304 807.375 304 819.041Z",
    fill: "#A4C529"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.913 811.438V833.85H344.169C348.266 833.85 350.765 831.981 350.765 826.138L350.767 818.955C350.767 813.723 349.062 811.438 345.177 811.438H339.913ZM351.888 874C351.299 872.146 350.867 870.965 350.867 865.035V853.572C350.867 846.805 348.692 844.3 343.685 844.3H339.913V874H329V801H345.494C356.878 801 361.776 806.537 361.776 817.786V823.523C361.776 831.049 359.435 835.939 354.542 838.329C360.02 840.724 361.833 846.265 361.833 853.895V865.158C361.833 868.689 361.934 871.298 363 874H351.888Z",
    fill: "#A4C529"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.195 857.294C399.195 862.509 401.423 864.53 405.004 864.53C408.535 864.53 410.808 862.509 410.808 857.294V817.676C410.808 812.448 408.535 810.456 405.004 810.456C401.423 810.456 399.195 812.448 399.195 817.676V857.294ZM388 818.403C388 806.681 393.979 800 405.004 800C415.97 800 422 806.681 422 818.403V856.567C422 868.28 415.97 875 405.004 875C393.981 875 388 868.28 388 856.567V818.403Z",
    fill: "#A4C529"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.149 811.438V836.151H465.386C468.954 836.151 470.904 834.5 470.904 829.254V818.31C470.904 813.106 468.954 811.438 465.386 811.438H460.149ZM482 819.041V828.53C482 840.232 476.532 846.605 465.386 846.605H460.149V874H449V801H465.386C476.532 801 482 807.375 482 819.041Z",
    fill: "#A4C529"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.016 831.764H533.151V842.202H518.016V863.587H537V874H507V801H537V811.438H518.016V831.764Z",
    fill: "#A4C529"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.97 811.438V833.85H579.217C583.247 833.85 585.79 831.981 585.79 826.138V818.955C585.79 813.723 584.101 811.438 580.223 811.438H574.97ZM586.852 874C586.264 872.146 585.847 870.965 585.847 865.035V853.572C585.847 846.805 583.68 844.3 578.686 844.3H574.97V874H564V801H580.498C591.838 801 596.675 806.537 596.675 817.786L596.676 823.523C596.676 831.049 594.43 835.939 589.568 838.329C594.957 840.724 596.772 846.265 596.772 853.895V865.158C596.772 868.689 596.882 871.298 598 874H586.852Z",
    fill: "#A4C529"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621 801H655V811.438H643.476V874H632.52V811.438H621V801Z",
    fill: "#A4C529"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680 801H691V874H680V801Z",
    fill: "#A4C529"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M731.019 831.764H746.094V842.202H731.019V863.587H750V874H720V801H750V811.438H731.019V831.764Z",
    fill: "#A4C529"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.603 800C802.401 800 807.888 806.681 807.888 818.403V821.248H797.461V817.676C797.461 812.448 795.417 810.456 791.931 810.456C788.37 810.456 786.391 812.448 786.391 817.676C786.392 832.787 808 835.599 808 856.567C808 868.28 802.401 875 791.499 875C780.643 875 775 868.28 775 856.567L775.001 851.522H785.484V857.294C785.484 862.509 787.685 864.415 791.171 864.415C794.72 864.415 796.924 862.509 796.924 857.294C796.924 842.204 775.319 839.356 775.319 818.403C775.321 806.681 780.807 800 791.603 800Z",
    fill: "#A4C529"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.784 923.149C302.81 923.096 302.824 922.978 302.824 922.797C302.824 922.355 302.674 921.971 302.375 921.645C302.076 921.32 301.706 921.156 301.264 921.156C300.327 921.156 299.768 921.598 299.587 922.483L295.804 941.659L289.8 922.953C289.462 921.937 288.76 921.43 287.693 921.43C286.68 921.43 285.978 921.937 285.588 922.953L280.363 941.619L275.606 921.47H268V923.382H268.702C270.002 923.382 270.875 923.656 271.316 924.203C271.628 924.594 271.953 925.503 272.29 926.935V926.975L277.125 948.571H281.377L286.993 928.654L292.685 946.619C293.153 948.128 294.024 948.884 295.298 948.884C296.779 948.884 297.676 948.116 297.99 946.58L302.784 923.149ZM323.141 948.571V945.877H314.25C313.289 945.877 312.704 945.799 312.496 945.641C312.183 945.46 312.027 944.953 312.027 944.119V935.762H321.19V933.066H312.027V925.96C312.027 925.204 312.209 924.709 312.573 924.477C312.858 924.294 313.404 924.203 314.211 924.203H321.112C322.049 924.203 322.516 923.734 322.516 922.797C322.516 922.458 322.38 922.158 322.107 921.899C321.835 921.638 321.515 921.508 321.152 921.508H303.877V923.422H304.267C305.644 923.422 306.528 923.696 306.919 924.242C307.205 924.658 307.347 925.608 307.347 927.093V945.839C307.528 947.659 308.505 948.571 310.273 948.571H323.141ZM346.186 927.679H348.02L347.98 923.187C346.005 921.729 343.885 921 341.624 921C338.921 921 336.79 921.619 335.229 922.855C333.67 924.092 332.89 925.764 332.89 927.874C332.89 930.217 333.774 932.118 335.541 933.575C336.373 934.252 337.817 935.176 339.87 936.349L340.844 936.895C343.651 938.457 345.056 940.227 345.056 942.206C345.056 944.575 343.51 945.759 340.415 945.759C339.585 945.759 338.805 945.628 338.076 945.369C337.764 945.239 337.024 944.887 335.853 944.314L335.698 944.236L335.347 944.002C334.697 943.56 334.202 943.339 333.864 943.339C333.526 943.339 333.221 943.495 332.949 943.807C332.675 944.119 332.538 944.472 332.538 944.86C332.538 945.252 332.759 945.708 333.202 946.227C335.178 948.051 337.634 948.962 340.571 948.962C343.196 948.962 345.355 948.324 347.045 947.048C348.916 945.641 349.852 943.663 349.852 941.113C349.852 939.472 349.403 938.053 348.507 936.855C347.611 935.658 346.134 934.473 344.081 933.302C343.795 933.12 343.339 932.859 342.717 932.52C340.922 931.558 339.779 930.867 339.286 930.452C338.193 929.513 337.647 928.369 337.647 927.015C337.647 924.776 338.855 923.656 341.274 923.656C344.549 923.656 346.186 924.97 346.186 927.6V927.679ZM372.664 945.525L364.398 933.38L371.611 923.616C371.82 923.33 371.924 923.031 371.924 922.718C371.924 922.302 371.774 921.931 371.475 921.605C371.175 921.28 370.831 921.118 370.441 921.118C369.947 921.118 369.545 921.326 369.233 921.743L361.395 932.443C360.226 932.078 359.64 931.427 359.64 930.49V921.47H351.491V923.422H351.997C353.375 923.422 354.233 923.656 354.571 924.124C354.83 924.488 354.961 925.414 354.961 926.897V945.603C355.299 947.581 356.339 948.571 358.081 948.571H359.64V936.153H360.032C360.551 936.153 361.032 936.425 361.473 936.972L361.591 937.168C361.695 937.35 363.059 939.447 365.684 943.455C366.568 944.835 367.543 946.292 368.608 947.83C369.311 948.558 370 948.923 370.677 948.923C371.352 948.923 371.905 948.708 372.333 948.278C372.762 947.848 372.976 947.294 372.976 946.619C372.976 946.254 372.873 945.889 372.664 945.525ZM393.098 948.571V945.877H384.208C383.247 945.877 382.661 945.799 382.453 945.641C382.141 945.46 381.985 944.953 381.985 944.119V935.762H391.147V933.066H381.985V925.96C381.985 925.204 382.167 924.709 382.531 924.477C382.816 924.294 383.362 924.203 384.168 924.203H391.07C392.006 924.203 392.474 923.734 392.474 922.797C392.474 922.458 392.338 922.158 392.065 921.899C391.793 921.638 391.472 921.508 391.11 921.508H373.834V923.422H374.225C375.602 923.422 376.486 923.696 376.876 924.242C377.161 924.658 377.305 925.608 377.305 927.093V945.839C377.486 947.659 378.463 948.571 380.23 948.571H393.098ZM414.389 924.124V921.47H394.424V927.717H396.335C396.543 926.076 396.894 925.067 397.387 924.692C397.881 924.313 399.013 924.124 400.781 924.124H402.067V945.603C402.301 947.581 403.302 948.571 405.071 948.571H406.748V924.124H414.389ZM433.226 945.447C432.029 946.02 430.716 946.306 429.286 946.306C426.816 946.306 424.997 945.342 423.827 943.415C422.658 941.49 422.072 938.497 422.072 934.434C422.072 930.686 422.54 927.944 423.476 926.213C424.411 924.482 425.907 923.616 427.961 923.616C431.392 923.616 433.213 924.983 433.42 927.717H435.253V922.368C433.147 921.457 430.872 921 428.429 921C424.555 921 421.707 922.087 419.889 924.26C418.068 926.436 417.157 929.826 417.157 934.434C417.157 939.51 418.062 943.194 419.868 945.487C421.676 947.777 424.594 948.923 428.623 948.923C430.912 948.923 432.783 948.624 434.24 948.025C435.617 947.452 436.306 946.734 436.306 945.877C436.306 945.068 435.942 944.666 435.215 944.666C434.981 944.666 434.318 944.927 433.226 945.447ZM459.82 948.571V921.47H455.141V930.484C455.141 931.187 454.875 931.798 454.342 932.325C453.808 932.845 453.178 933.106 452.45 933.106H445.47V921.47L437.358 921.508V923.422H437.864C439.268 923.422 440.108 923.61 440.38 923.988C440.654 924.366 440.79 925.387 440.79 927.053V946.071C440.79 946.801 441.011 947.4 441.452 947.867C441.895 948.337 442.454 948.571 443.129 948.571C443.806 948.571 444.364 948.33 444.807 947.848C445.249 947.368 445.47 946.761 445.47 946.033V938.301C445.47 937.598 445.716 936.998 446.21 936.503C446.704 936.01 447.315 935.762 448.043 935.762H455.141V948.571H459.82ZM491.758 923.382C491.861 923.201 491.912 922.953 491.912 922.641C491.912 921.573 491.446 921.038 490.509 921.038C489.937 921.038 489.509 921.299 489.223 921.821L483.139 932.52L477.016 921.47L469.374 921.508V923.422H469.608C470.674 923.422 471.473 923.572 472.007 923.871C472.54 924.17 473.04 924.723 473.508 925.53L479.63 936.113V945.603C479.63 946.513 479.908 947.237 480.467 947.77C481.026 948.303 481.762 948.571 482.672 948.571H484.31V936.075L491.758 923.382ZM516.364 935.098C516.364 930.256 515.519 926.697 513.829 924.418C512.138 922.14 509.461 921 505.795 921C502 921 499.25 922.12 497.547 924.359C495.845 926.598 494.993 930.178 494.993 935.098C494.993 939.862 495.865 943.364 497.607 945.603C499.347 947.842 502.079 948.962 505.795 948.962C509.461 948.962 512.138 947.842 513.829 945.603C515.519 943.364 516.364 939.862 516.364 935.098ZM511.41 934.98C511.41 938.521 511.215 940.955 510.825 942.284C510.072 944.992 508.396 946.345 505.795 946.345C503.768 946.345 502.287 945.433 501.349 943.613C500.415 941.789 499.946 938.95 499.946 935.098C499.946 931.088 500.402 928.186 501.311 926.389C502.22 924.594 503.717 923.696 505.795 923.696C508.37 923.696 510.045 925.048 510.825 927.756C511.215 929.085 511.41 931.493 511.41 934.98ZM540.851 938.065V922.915C540.851 922.394 540.684 921.963 540.345 921.624C540.007 921.286 539.591 921.118 539.096 921.118C538.604 921.118 538.181 921.293 537.83 921.645C537.48 921.996 537.303 922.419 537.303 922.915V938.497C537.303 941.073 536.816 943.026 535.841 944.354C534.865 945.681 533.509 946.345 531.766 946.345C529.868 946.345 528.562 945.681 527.848 944.354C527.133 943.026 526.775 940.774 526.775 937.598V921.47H518.586V923.382H518.936C520.366 923.382 521.251 923.65 521.589 924.183C521.927 924.717 522.095 925.817 522.095 927.483V939.59C522.095 942.842 522.855 945.226 524.377 946.734C525.898 948.246 528.271 949 531.494 949C535.107 949 537.616 948.065 539.02 946.188C540.241 944.548 540.851 941.84 540.851 938.065ZM565.263 945.565L559.881 935.332C563.027 934.578 564.599 932.43 564.599 928.889C564.599 923.942 560.947 921.47 553.643 921.47H544.244V923.382H544.751C546.103 923.382 546.942 923.603 547.267 924.046C547.59 924.488 547.754 925.543 547.754 927.209L547.794 945.603C548.105 947.581 549.106 948.571 550.796 948.571H552.435V938.729C552.435 937.505 552.669 936.777 553.135 936.543C553.422 936.412 553.876 936.349 554.5 936.349H554.852C554.93 936.374 555.059 936.387 555.242 936.387L561.167 947.751C561.583 948.558 562.247 948.962 563.156 948.962C563.833 948.962 564.392 948.739 564.833 948.297C565.276 947.854 565.497 947.294 565.497 946.619C565.497 946.201 565.419 945.85 565.263 945.565ZM552.435 930.686V924.163H554.228C558.128 924.163 560.076 925.726 560.076 928.849C560.076 932.131 558.257 933.771 554.618 933.771C553.603 933.771 552.981 933.536 552.745 933.066C552.589 932.807 552.511 932.091 552.511 930.92C552.511 930.867 552.498 930.827 552.472 930.802C552.446 930.777 552.435 930.737 552.435 930.686ZM585.462 921.43H574.856V923.382H575.247C576.65 923.382 577.548 923.683 577.938 924.281C578.223 924.698 578.367 925.674 578.367 927.209V945.212C578.367 947.452 579.368 948.571 581.37 948.571H584.175C588.803 948.571 592.066 947.894 593.964 946.54C596.799 944.535 598.215 940.683 598.215 934.98C598.215 930.035 597.247 926.539 595.31 924.496C593.374 922.453 590.09 921.43 585.462 921.43ZM585.228 945.915H583.084V924.085H583.981C587.231 924.085 589.414 924.502 590.532 925.335C592.353 926.714 593.25 929.968 593.224 935.098C593.197 939.237 592.665 942.05 591.623 943.533C590.505 945.121 588.375 945.915 585.228 945.915ZM621.651 945.565L616.27 935.332C619.415 934.578 620.988 932.43 620.988 928.889C620.988 923.942 617.335 921.47 610.031 921.47H600.632V923.382H601.14C602.492 923.382 603.33 923.603 603.655 924.046C603.98 924.488 604.144 925.543 604.144 927.209L604.182 945.603C604.494 947.581 605.496 948.571 607.185 948.571H608.822V938.729C608.822 937.505 609.056 936.777 609.522 936.543C609.809 936.412 610.265 936.349 610.889 936.349H611.239C611.317 936.374 611.448 936.387 611.63 936.387L617.557 947.751C617.972 948.558 618.635 948.962 619.546 948.962C620.221 948.962 620.78 948.739 621.223 948.297C621.665 947.854 621.885 947.294 621.885 946.619C621.885 946.201 621.807 945.85 621.651 945.565ZM608.822 930.686V924.163H610.615C614.515 924.163 616.466 925.726 616.466 928.849C616.466 932.131 614.644 933.771 611.005 933.771C609.991 933.771 609.368 933.536 609.134 933.066C608.976 932.807 608.9 932.091 608.9 930.92C608.9 930.867 608.887 930.827 608.86 930.802C608.835 930.777 608.822 930.737 608.822 930.686ZM642.748 948.571V945.877H633.857C632.896 945.877 632.311 945.799 632.103 945.641C631.79 945.46 631.634 944.953 631.634 944.119V935.762H640.798V933.066H631.634V925.96C631.634 925.204 631.816 924.709 632.18 924.477C632.465 924.294 633.011 924.203 633.817 924.203H640.721C641.657 924.203 642.125 923.734 642.125 922.797C642.125 922.458 641.989 922.158 641.715 921.899C641.443 921.638 641.123 921.508 640.761 921.508H623.484V923.422H623.876C625.253 923.422 626.137 923.696 626.526 924.242C626.812 924.658 626.956 925.608 626.956 927.093V945.839C627.137 947.659 628.114 948.571 629.881 948.571H642.748ZM666.38 948.571L656.787 921C654.604 921 653.109 922.133 652.303 924.397L644.387 946.932C644.309 947.166 644.269 947.36 644.269 947.517C644.269 948.48 644.828 948.962 645.946 948.962C646.414 948.962 646.779 948.739 647.038 948.297C647.22 947.959 647.545 947.1 648.015 945.721L648.169 945.252L648.403 944.472C648.846 942.987 649.169 942.075 649.379 941.736C649.899 940.877 650.679 940.448 651.718 940.448H658.814L661.622 948.571H666.38ZM656.241 937.792H650.744L654.292 927.287L657.333 936.387C657.437 936.699 657.489 936.933 657.489 937.09C657.489 937.558 657.072 937.792 656.241 937.792ZM696.29 921.47H690.363L683.303 942.634L676.051 921.47H666.965V923.422H667.199C668.709 923.422 669.63 923.624 669.968 924.027C670.306 924.431 670.475 925.4 670.475 926.935V947.36C670.475 947.804 670.637 948.175 670.962 948.474C671.288 948.773 671.671 948.923 672.113 948.923C672.556 948.923 672.931 948.773 673.244 948.474C673.556 948.175 673.712 947.804 673.712 947.36V927.443L680.379 947.321C680.744 948.389 681.485 948.923 682.602 948.923C683.773 948.923 684.526 948.402 684.864 947.36L691.572 927.249V948.571H696.29V921.47ZM729.669 948.571V921.47H724.99V930.484C724.99 931.187 724.725 931.798 724.192 932.325C723.659 932.845 723.027 933.106 722.301 933.106H715.32V921.47L707.209 921.508V923.422H707.715C709.118 923.422 709.958 923.61 710.23 923.988C710.504 924.366 710.641 925.387 710.641 927.053V946.071C710.641 946.801 710.861 947.4 711.303 947.867C711.746 948.337 712.305 948.571 712.98 948.571C713.657 948.571 714.214 948.33 714.657 947.848C715.1 947.368 715.32 946.761 715.32 946.033V938.301C715.32 937.598 715.566 936.998 716.06 936.503C716.555 936.01 717.165 935.762 717.893 935.762H724.99V948.571H729.669ZM756.03 935.098C756.03 930.256 755.186 926.697 753.495 924.418C751.806 922.14 749.129 921 745.463 921C741.668 921 738.918 922.12 737.215 924.359C735.513 926.598 734.661 930.178 734.661 935.098C734.661 939.862 735.533 943.364 737.273 945.603C739.015 947.842 741.746 948.962 745.463 948.962C749.129 948.962 751.806 947.842 753.495 945.603C755.186 943.364 756.03 939.862 756.03 935.098ZM751.08 934.98C751.08 938.521 750.884 940.955 750.494 942.284C749.741 944.992 748.064 946.345 745.463 946.345C743.434 946.345 741.955 945.433 741.017 943.613C740.082 941.789 739.614 938.95 739.614 935.098C739.614 931.088 740.069 928.186 740.979 926.389C741.888 924.594 743.383 923.696 745.463 923.696C748.037 923.696 749.715 925.048 750.494 927.756C750.884 929.085 751.08 931.493 751.08 934.98ZM787.656 921.47H781.729L774.672 942.634L767.418 921.47H758.331V923.422H758.565C760.074 923.422 760.996 923.624 761.333 924.027C761.672 924.431 761.841 925.4 761.841 926.935V947.36C761.841 947.804 762.003 948.175 762.328 948.474C762.653 948.773 763.037 948.923 763.48 948.923C763.921 948.923 764.298 948.773 764.611 948.474C764.921 948.175 765.077 947.804 765.077 947.36V927.443L771.746 947.321C772.111 948.389 772.852 948.923 773.968 948.923C775.139 948.923 775.893 948.402 776.231 947.36L782.938 927.249V948.571H787.656V921.47ZM810 948.571V945.877H801.109C800.148 945.877 799.564 945.799 799.355 945.641C799.042 945.46 798.887 944.953 798.887 944.119V935.762H808.049V933.066H798.887V925.96C798.887 925.204 799.068 924.709 799.433 924.477C799.719 924.294 800.264 924.203 801.069 924.203H807.973C808.908 924.203 809.376 923.734 809.376 922.797C809.376 922.458 809.24 922.158 808.967 921.899C808.694 921.638 808.374 921.508 808.011 921.508H790.736V923.422H791.127C792.504 923.422 793.388 923.696 793.778 924.242C794.064 924.658 794.208 925.608 794.208 927.093V945.839C794.389 947.659 795.366 948.571 797.132 948.571H810Z",
    fill: "#69A439"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808 896H271V899H808V896Z",
    fill: "#69A439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6555_439",
    x: 0,
    y: 0,
    width: 1098,
    height: 1098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6555_439"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6555_439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6555_439",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogo);
export default __webpack_public_path__ + "static/media/clientLogo.e322b162e109547b08e5f6e07ce00597.svg";
export { ForwardRef as ReactComponent };